import * as DAF from '@h3/daf';

// 注册数据访问框架
export function initEntry() {
    window.h3Daf = DAF;
}
